"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.timeEnd = exports.time = exports.error = exports.warn = exports.info = exports.log = exports.debug = exports.setLogger = void 0;
/**
 * A no-op logger
 */

var DummyLogger = /*#__PURE__*/function () {
  function DummyLogger() {
    (0, _classCallCheck2.default)(this, DummyLogger);
  }

  (0, _createClass2.default)(DummyLogger, [{
    key: "log",
    value: function log() {}
  }, {
    key: "debug",
    value: function debug() {}
  }, {
    key: "info",
    value: function info() {}
  }, {
    key: "warn",
    value: function warn() {}
  }, {
    key: "error",
    value: function error() {}
  }, {
    key: "time",
    value: function time() {}
  }, {
    key: "timeEnd",
    value: function timeEnd() {}
  }]);
  return DummyLogger;
}();

var LOGGER = new DummyLogger();
/**
 *
 * @param {object} logger the new logger. e.g `console`
 */

function setLogger() {
  var logger = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new DummyLogger();
  LOGGER = logger;
}

exports.setLogger = setLogger;

function debug() {
  var _LOGGER;

  return (_LOGGER = LOGGER).debug.apply(_LOGGER, arguments);
}

exports.debug = debug;

function log() {
  var _LOGGER2;

  return (_LOGGER2 = LOGGER).log.apply(_LOGGER2, arguments);
}

exports.log = log;

function info() {
  var _LOGGER3;

  return (_LOGGER3 = LOGGER).info.apply(_LOGGER3, arguments);
}

exports.info = info;

function warn() {
  var _LOGGER4;

  return (_LOGGER4 = LOGGER).warn.apply(_LOGGER4, arguments);
}

exports.warn = warn;

function error() {
  var _LOGGER5;

  return (_LOGGER5 = LOGGER).error.apply(_LOGGER5, arguments);
}

exports.error = error;

function time() {
  var _LOGGER6;

  return (_LOGGER6 = LOGGER).time.apply(_LOGGER6, arguments);
}

exports.time = time;

function timeEnd() {
  var _LOGGER7;

  return (_LOGGER7 = LOGGER).timeEnd.apply(_LOGGER7, arguments);
}

exports.timeEnd = timeEnd;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7O0FBQUE7Ozs7SUFHTUEsVzs7Ozs7OztXQUNKLGVBQUcsQ0FBSzs7O1dBRVIsaUJBQUssQ0FBSzs7O1dBRVYsZ0JBQUksQ0FBSzs7O1dBRVQsZ0JBQUksQ0FBSzs7O1dBRVQsaUJBQUssQ0FBSzs7O1dBRVYsZ0JBQUksQ0FBSzs7O1dBRVQsbUJBQU8sQ0FBSzs7Ozs7QUFHZCxJQUFJQyxNQUFNLEdBQUcsSUFBSUQsV0FBSixFQUFiO0FBRUE7Ozs7O0FBSUEsU0FBZ0JFLFNBQWhCLEdBQW9EO0VBQUEsSUFBMUJDLE1BQTBCLHVFQUFqQixJQUFJSCxXQUFKLEVBQWlCO0VBQ2xEQyxNQUFNLEdBQUdFLE1BQVQ7QUFDRDs7QUFGREM7O0FBSUEsU0FBZ0JDLEtBQWhCLEdBQTZCO0VBQUE7O0VBQzNCLE9BQU8saUJBQU0sRUFBQ0EsS0FBUCwwQkFBUDtBQUNEOztBQUZERDs7QUFJQSxTQUFnQkUsR0FBaEIsR0FBMkI7RUFBQTs7RUFDekIsT0FBTyxrQkFBTSxFQUFDQSxHQUFQLDJCQUFQO0FBQ0Q7O0FBRkRGOztBQUlBLFNBQWdCRyxJQUFoQixHQUE0QjtFQUFBOztFQUMxQixPQUFPLGtCQUFNLEVBQUNBLElBQVAsMkJBQVA7QUFDRDs7QUFGREg7O0FBSUEsU0FBZ0JJLElBQWhCLEdBQTRCO0VBQUE7O0VBQzFCLE9BQU8sa0JBQU0sRUFBQ0EsSUFBUCwyQkFBUDtBQUNEOztBQUZESjs7QUFJQSxTQUFnQkssS0FBaEIsR0FBNkI7RUFBQTs7RUFDM0IsT0FBTyxrQkFBTSxFQUFDQSxLQUFQLDJCQUFQO0FBQ0Q7O0FBRkRMOztBQUlBLFNBQWdCTSxJQUFoQixHQUE0QjtFQUFBOztFQUMxQixPQUFPLGtCQUFNLEVBQUNBLElBQVAsMkJBQVA7QUFDRDs7QUFGRE47O0FBSUEsU0FBZ0JPLE9BQWhCLEdBQStCO0VBQUE7O0VBQzdCLE9BQU8sa0JBQU0sRUFBQ0EsT0FBUCwyQkFBUDtBQUNEOztBQUZEUCIsIm5hbWVzIjpbIkR1bW15TG9nZ2VyIiwiTE9HR0VSIiwic2V0TG9nZ2VyIiwibG9nZ2VyIiwiZXhwb3J0cyIsImRlYnVnIiwibG9nIiwiaW5mbyIsIndhcm4iLCJlcnJvciIsInRpbWUiLCJ0aW1lRW5kIl0sInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL2Rpc3QtbW9kdWxlL2xvZ2dpbmcuanMiXSwic291cmNlc0NvbnRlbnQiOltudWxsXX0=